module.exports = __webpack_public_path__ + "static/media/chestCircum.4ceafdbc.png";